/**
 * Resolve which app chrome shell to render for a pathname.
 *
 * Chrome matrix (one source of truth):
 * - listener  → ListenerSidebar + ListenerTopBar (public, commerce, /auth form)
 * - creator   → CreatorShell + dashboard nav (/dashboard/* only)
 * - auth      → centered AuthShell, no sidebar (one-shot token / email links)
 * - minimal   → bare (maintenance, anonymous marketing landing on `/`)
 *
 * @param {string} pathname
 * @param {{ isAuthenticated?: boolean }} [options]
 * @returns {'listener' | 'creator' | 'auth' | 'minimal'}
 */
export function resolveAppShell(pathname, options = {}) {
  const path = String(pathname || '/').replace(/\/+$/, '') || '/';
  const isAuthenticated = Boolean(options.isAuthenticated);

  if (path === '/maintenance') return 'minimal';

  // Variant 3: anonymous `/` is marketing landing (own chrome, no sidebar/player).
  if (path === '/' && !isAuthenticated) return 'minimal';

  // Full-bleed creator onboarding owns its chrome (no AuthShell chrome).
  if (path === '/onboarding' || path.startsWith('/onboarding/')) {
    return 'minimal';
  }

  // One-shot email / token flows: no app nav (focused card only).
  if (
    path.startsWith('/verify-email/') ||
    path.startsWith('/reset-password/') ||
    path.startsWith('/delete-account/confirm/') ||
    path.startsWith('/change-username/confirm/') ||
    path.startsWith('/change-email/confirm/') ||
    path.startsWith('/donations/cancel/confirm/') ||
    path.startsWith('/cancel-subscription/') ||
    path.startsWith('/download/')
  ) {
    return 'auth';
  }

  if (path === '/dashboard' || path.startsWith('/dashboard/')) {
    return 'creator';
  }

  // Public app + login/register keep full listener chrome (sidebar + top bar).
  // /auth is listener so users never "lose" navigation when signing in.
  return 'listener';
}

export default resolveAppShell;
